import { render } from "./LineBreak.vue?vue&type=template&id=47d4e564&scoped=true"
const script = {}

import "./LineBreak.vue?vue&type=style&index=0&id=47d4e564&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d4e564"]])

export default __exports__